import api from "../../config/api";

const state = {
    timezones: {},
    countries: {}
}

const mutations = {
    SET_TIMEZONES(state, payload) {
        state.timezones = payload;
    },
    SET_COUNTRIES(state, payload) {
        state.countries = payload;
    },
}

const actions = {

    async getTimezones({ commit }) {
        try {
            await api.get(`/manageuserajax/timezones`, {
                cmd: "gettimezones",
            })
                .then((response) => {
                    commit('SET_TIMEZONES', response.data.output);
                })
                .catch((error) => {
                    console.log("Error in fetching data", error);
                });
        } catch (error) {
            console.error('Error fetching API data:', error);
        }
    },

    async getCountries({ commit }) {
        try {
            await api.get(`/manageuserajax/countries`, {
                cmd: "getcountries",
            })
                .then((response) => {
                    commit('SET_COUNTRIES', response.data.output);
                })
                .catch((error) => {
                    console.log("Error in fetching data", error);
                });
        } catch (error) {
            console.error('Error fetching API data:', error);
        }
    },

}

const getters = {
    stCountries: state => state.countries,
    stTimezones: state => state.timezones
}

export default {
    state,
    mutations,
    actions,
    getters
}